import { Tag, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { colors } from "config/theme";

interface CopyableEmailTagProps {
  value?: string | null;
}

export const CopyableEmailTag: React.FC<CopyableEmailTagProps> = ({ value }) => {
  if (!value) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    message.success("Email copied");
  };

  return (
    <Tag>
      {value} <CopyOutlined onClick={handleCopy} style={{ cursor: "pointer", color: colors.primary }} />
    </Tag>
  );
};
